// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".logo[data-v-42d8b103]{align-items:center;display:inline-flex}.logo__mark[data-v-42d8b103]{height:30px;margin-right:10px;width:40px}.logo__text[data-v-42d8b103]{fill:currentColor;height:17px;width:108px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
